import React from "react";
import Header from "../../general/Header";
import Aside from "../../general/Aside";
import Footer from "../../general/Footer";
import axios from '../../../axios/axiosconf';
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../../general/Loading";
import SelectorCiudad from "../../custom/SelectorCiudad";
import Unauthorized from "../../general/Unauthorized";
import { getUserData, persistUserData } from "../../../../utils/userAccessHelpers";

function EditarUsuario() {

    //const queryParams = new URLSearchParams(window.location.search);
    const queryParams = useLocation().search;
    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    const search = useLocation().search;
    const id = new URLSearchParams(search).get('id');
    const [idUsuario, setIdUsuario] = useState();

    //const [nombre, setNombre] = useState('');

    const [cargos, setCargos] = useState([]);
    const [tiposContrato, setTiposContrato] = useState([]);
    const [especialidades, setEspecialidades] = useState([]);

    const [roles, setRoles] = useState([]);
    const [name, setName] = useState('');
    const [lastname, setLastname] = useState('');
    const [email, setEmail] = useState('');
    const [documento, setDocumento] = useState('');
    const [tipoDocumento, setTipoDocumento] = useState('');
    const [celular, setCelular] = useState('');
    const [cargo, setCargo] = useState('');
    const [tipoContrato, setTipoContrato] = useState('');
    const [registroMedico, setRegistroMedico] = useState('');
    const [especialidad, setEspecialidad] = useState('');
    const [codigoHabilitacion, setCodigoHabilitacion] = useState('');
    const [direccion, setDireccion] = useState('');
    const [ciudadResidencia, setCiudadResidencia] = useState('');
    const [telefono, setTelefono] = useState('');
    const [fechaNacimiento, setFechaNacimiento] = useState('');
    const [estadoCivil, setEstadoCivil] = useState('');
    const [fechaIngreso, setFechaIngreso] = useState('');
    const [porcentajeContratado, setPorcentajeContratado] = useState('');

    const [crearCuenta, setCrearCuenta] = useState();
    const [asignarRolesVisible, setAsignarRolesVisible] = useState('hide');
    const [ocultarCrearCuenta, setOcultarCrearCuenta] = useState('');
    const [usuarioTieneCuenta, setUsuarioTieneCuenta] = useState(false);
    const [esUsuarioSistema, setEsUsuarioSistema] = useState(false);
    const [usuarioActivo, setUsuarioActivo] = useState(0);
    const [password, setPassword] = useState('');
    const [usuariosDisponibles, setUsuariosDisponibles] = useState(0);
    const [usuariosCreados, setUsuariosCreados] = useState(0);
    const [cuposMedicos, setCuposMedicos] = useState({ disponibles: 0, creados: 0 });
    const [cuposAdmin, setCuposAdmin] = useState({ disponibles: 0, creados: 0 });

    const [tipoUsuario, setTipoUsuario] = useState('');
    const [usuarioActualizado, setUsuarioActualizado] = useState(0);

    // Estados para controlar acordeones
    const [acordeonDatosBasicos, setAcordeonDatosBasicos] = useState(true);
    const [acordeonDatosProfesional, setAcordeonDatosProfesional] = useState(false);
    const [acordeonUsuarioSistema, setAcordeonUsuarioSistema] = useState(true);



    const [usrRoles, setUsrRoles] = useState([]);
    const [facturador, setFacturador] = useState(1); // 🆕 Campo facturador - Default 1 (No es facturador)
    const [agendaFavoritaId, setAgendaFavoritaId] = useState(null);
    const [agendaFavoritaNombre, setAgendaFavoritaNombre] = useState('');
    const [creandoAgenda, setCreandoAgenda] = useState(false);

    const [errorlist, setErrorlist] = useState({});
    const [banner, setBanner] = useState({ type: '', message: '' });

    let history = useHistory();

    /** Solo médico (0) con cuenta: diligenciar_historias = 1; administrativo siempre 0 */
    const resolverDiligenciarHistorias = () => {
        const tieneCuenta = crearCuenta || esUsuarioSistema;
        if (!tieneCuenta) {
            return 0;
        }
        return parseInt(tipoUsuario, 10) === 0 ? 1 : 0;
    };

    const clearBanner = () => setBanner({ type: '', message: '' });

    const normalizeApiErrors = (err) => {
        const out = {};
        const data = err.response?.data;
        if (!data) {
            return { general: 'Error de red o del servidor. Intente de nuevo.' };
        }
        if (data.errors) {
            Object.keys(data.errors).forEach((key) => {
                const v = data.errors[key];
                out[key] = Array.isArray(v) ? v[0] : String(v);
            });
            return out;
        }
        if (data.message) {
            return { general: data.message };
        }
        if (typeof data.error === 'string') {
            return { general: data.error };
        }
        return { general: 'Error al guardar los cambios.' };
    };

    const scrollToFirstError = (errKeys) => {
        const order = [
            'name',
            'lastname',
            'tipo_documento',
            'numero_documento',
            'documento',
            'email',
            'celular',
            'cargo',
            'tipo_contrato',
            'porcentaje_contratado',
            'crear_cuenta',
            'tipo_usuario',
            'password'
        ];
        const first = order.find((k) => errKeys.includes(k)) || errKeys[0];
        if (!first || first === 'general') return;
        const idMap = {
            numero_documento: 'documento',
            password: 'password_edit'
        };
        const domId = idMap[first] || first;
        const el = document.getElementById(domId);
        el?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    const summarizeFieldErrors = (obj) => {
        if (!obj || typeof obj !== 'object') return '';
        return Object.entries(obj)
            .filter(([k, v]) => k !== 'general' && v)
            .map(([, v]) => v)
            .join(' · ');
    };

    let userdata = [];


    const addRole = (roleId) => {
        const userRoles = [...usrRoles];
        const roleIndex = userRoles.indexOf(roleId);
        if (roleIndex > -1) {
            userRoles.splice(roleIndex, 1);
        } else {
            userRoles.push(roleId);
        }
        setUsrRoles(userRoles);
    }

    useEffect(() => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        console.log('DEBUG EditarUsuario - userdata:', userdata); // ✅ DEBUG
        console.log('DEBUG EditarUsuario - permissions:', userdata.permissions); // ✅ DEBUG
        console.log('DEBUG EditarUsuario - up (sistema antiguo):', userdata.up); // ✅ DEBUG

        // 🔒 VALIDACIÓN DE PERMISOS - Verificar acceso a gestión de personal (con fallback)
        let tienePermiso = false;

        // Intentar con el sistema nuevo
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            tienePermiso = userdata.permissions.some(permission => permission.slug === 'gestionPersonal');
            console.log('DEBUG EditarUsuario - Usando sistema nuevo de permisos');
        }
        // Fallback al sistema antiguo
        else if (userdata.up && userdata.up.includes('gestionPersonal')) {
            tienePermiso = true;
            console.log('DEBUG EditarUsuario - Usando sistema antiguo de permisos (fallback)');
        }

        console.log('DEBUG EditarUsuario - tienePermiso gestionPersonal:', tienePermiso); // ✅ DEBUG

        if (!tienePermiso) {
            setHasPermission(false);
            return; // Detener ejecución si no tiene permisos
        }

        setHasPermission(true);

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        setIdUsuario(id);

        axios.get('/get-client', config)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('Error cargando cliente');
            });

        // 📊 CARGAR INFORMACIÓN DE USUARIOS DISPONIBLES
        axios.get('/parametros-cliente', config)
            .then(response => {
                if (response.status === 200 && response.data) {
                    setUsuariosDisponibles(response.data.numero_usuarios_disponibles || 0);
                    setUsuariosCreados(response.data.usuarios_creados || 0);
                    setCuposMedicos({
                        disponibles: response.data.usuarios_medicos_disponibles || 0,
                        creados: response.data.usuarios_medicos_creados || 0,
                    });
                    setCuposAdmin({
                        disponibles: response.data.usuarios_administrativos_disponibles || 0,
                        creados: response.data.usuarios_administrativos_creados || 0,
                    });
                }
            })
            .catch(error => {
                console.log('Error cargando parámetros cliente');
                setUsuariosDisponibles(0);
                setUsuariosCreados(0);
            })

        axios.get('user?id=' + id, config)
            .then(response => {
                if (response.status === 200) {
                    setName(response.data[0].name || '');
                    setLastname(response.data[0].lastname || '');
                    setEmail(response.data[0].email || '');
                    setDocumento(response.data[0].numero_documento || '');
                    setTipoDocumento(response.data[0].tipo_documento || '');
                    setCelular(response.data[0].celular || '');
                    setCargo(response.data[0].cargo || '');
                    setTipoContrato(response.data[0].tipo_contrato || '');
                    setRegistroMedico(response.data[0].registro_medico || '');
                    setEspecialidad(response.data[0].especialidad || '');
                    setCodigoHabilitacion(response.data[0].codigo_habilitacion || '');

                    setTelefono(response.data[0].telefono || '');
                    setDireccion(response.data[0].direccion || '');

                    setCiudadResidencia(response.data[0].id_ciudad || '');
                    setFechaNacimiento(response.data[0].fecha_nacimiento || '');
                    setEstadoCivil(response.data[0].estado_civil || '');
                    setFechaIngreso(response.data[0].fecha_ingreso || '');
                    setPorcentajeContratado(response.data[0].porcentaje_contratado || '');
                    setFacturador(response.data[0].facturador !== undefined ? response.data[0].facturador : 1); // 🆕 Cargar campo facturador
                    setAgendaFavoritaId(response.data[0].agenda_favorita || null);
                    setAgendaFavoritaNombre(response.data[0].agenda_favorita_nombre || '');
                    setTipoUsuario(
                        response.data[0].tipo_usuario !== null && response.data[0].tipo_usuario !== undefined
                            ? String(response.data[0].tipo_usuario)
                            : (parseInt(response.data[0].activo, 10) === 1 ? '0' : '1')
                    );
                    setUsuarioActualizado(response.data[0].usuario_actualizado || 0);
                    setUsuarioActivo(parseInt(response.data[0].activo, 10) || 0);

                    const activo = parseInt(response.data[0].activo, 10) === 1;
                    if (activo) {
                        setCrearCuenta(true);
                        setAsignarRolesVisible('');
                        setOcultarCrearCuenta('hide');
                        setEsUsuarioSistema(true);
                        setUsuarioTieneCuenta(parseInt(response.data[0].usuario_actualizado, 10) === 1);
                    } else {
                        setCrearCuenta(false);
                        setAsignarRolesVisible('hide');
                        setOcultarCrearCuenta('');
                        setEsUsuarioSistema(false);
                        setUsuarioTieneCuenta(false);
                    }

                }
            })
            .catch(error => console.log('Error cargando usuario'))

        axios.get('/user-roles?id=' + id, config)
            .then(response => {
                if (response.status === 200) {
                    setRoles(response.data);
                    let rolesExistentes = [];
                    for (let j = 0; j < response.data.length; j++) {
                        let r = response.data[j];
                        if (r.ru_id != null) {
                            rolesExistentes.push(r.id);
                        }
                    }
                    setUsrRoles(rolesExistentes);
                }
            })
            .catch(error => {
                console.log('Error cargando roles');
            });

        axios.get('/cargos', config)
            .then(response => {
                if (response.status === 200) {
                    setCargos(response.data);
                }
            })
            .catch(error => {
                console.log('Error cargando cargos');
            });


        axios.get('/tipos-contrato', config)
            .then(response => {
                if (response.status === 200) {
                    setTiposContrato(response.data);
                }
            })
            .catch(error => {
                console.log('Error cargando tipos contrato');
            });

        axios.get('/especialidades', config)
            .then(response => {
                if (response.status === 200) {
                    setEspecialidades(response.data);
                }
            })
            .catch(error => {
                console.log('Error cargando especialidades');
            })
    }, []);



    const cuposLibresMedicos = Math.max(0, cuposMedicos.disponibles - cuposMedicos.creados);
    const cuposLibresAdmin = Math.max(0, cuposAdmin.disponibles - cuposAdmin.creados);
    const hayCuposDisponibles = cuposLibresMedicos > 0 || cuposLibresAdmin > 0;
    const cuposLibresTipo = tipoUsuario === '1' ? cuposLibresAdmin : cuposLibresMedicos;

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        clearBanner();
        setErrorlist({});

        const errores = {};

        if (!name || name.trim() === '') {
            errores.name = 'El nombre es requerido';
        }

        if (!lastname || lastname.trim() === '') {
            errores.lastname = 'El apellido es requerido';
        }

        if (!email || email.trim() === '') {
            errores.email = 'El email es requerido';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) {
            errores.email = 'El email no tiene un formato válido';
        }

        if (!documento || documento.trim() === '') {
            errores.numero_documento = 'El número de documento es requerido';
        }

        if (!tipoDocumento || tipoDocumento.trim() === '') {
            errores.tipo_documento = 'El tipo de documento es requerido';
        }

        if (!celular || celular.trim() === '') {
            errores.celular = 'El teléfono celular es requerido';
        }

        if (!tipoContrato || tipoContrato === '') {
            errores.tipo_contrato = 'El tipo de contrato es obligatorio';
        }

        // Validación: porcentaje contratado si se indica
        if (porcentajeContratado && porcentajeContratado !== '') {
            const porcentaje = parseInt(porcentajeContratado, 10);
            if (isNaN(porcentaje) || porcentaje < 0 || porcentaje > 100) {
                errores.porcentaje_contratado = 'El porcentaje debe ser un número entre 0 y 100';
            }
        }

        if (crearCuenta && !esUsuarioSistema) {
            if (tipoUsuario !== '0' && tipoUsuario !== '1') {
                errores.tipo_usuario = 'Seleccione el tipo de usuario';
            } else if (cuposLibresTipo <= 0) {
                errores.tipo_usuario = tipoUsuario === '1'
                    ? 'No hay cupos disponibles para usuarios administrativos'
                    : 'No hay cupos disponibles para usuarios médicos';
            }

            const pwd = String(password || '').trim();
            if (!pwd) {
                errores.password = 'La contraseña es obligatoria para activar el acceso al sistema';
            } else if (pwd.length < 6) {
                errores.password = 'La contraseña debe tener al menos 6 caracteres';
            }
        } else if (password && password.length > 0 && password.length < 6) {
            errores.password = 'La contraseña debe tener al menos 6 caracteres';
        }

        if (Object.keys(errores).length > 0) {
            setErrorlist(errores);
            const resumen = summarizeFieldErrors(errores);
            setBanner({
                type: 'warning',
                message:
                    resumen ||
                    'Revise los campos obligatorios (marcados con *) y los mensajes debajo de cada campo.'
            });
            requestAnimationFrame(() => scrollToFirstError(Object.keys(errores)));
            setLoading(false);
            return;
        }

        //console.log('userRoles: '+userRoles);
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const conf = {
            headers: { Authorization: 'Bearer ' + userdata.access_token },
            client_id: client.client_id,
            name: name,
            lastname: lastname,
            email: email,
            numero_documento: documento,
            tipo_documento: tipoDocumento,
            celular: celular,
            // 🔧 VALIDACIÓN: Convertir strings vacíos a null para campos integer
            cargo: cargo && cargo !== '' ? parseInt(cargo) : null,
            tipo_contrato: tipoContrato && tipoContrato !== '' ? parseInt(tipoContrato) : null,
            especialidad: especialidad && especialidad !== '' ? parseInt(especialidad) : null,
            // 🔧 VALIDACIÓN: Campos de texto pueden ser vacíos
            registro_medico: registroMedico || null,
            codigo_habilitacion: codigoHabilitacion || null,
            id: idUsuario,
            crear_cuenta: crearCuenta || esUsuarioSistema,
            activar_directo: (crearCuenta && !esUsuarioSistema) ? true : false,
            direccion: direccion || null,
            // 🔧 VALIDACIÓN: Ciudad debe ser integer (ID de ciudad) o null
            ciudad: ciudadResidencia && ciudadResidencia !== '' ? parseInt(ciudadResidencia) : null,
            telefono: telefono || null,
            fecha_nacimiento: fechaNacimiento || null,
            estado_civil: estadoCivil || null,
            fecha_ingreso: fechaIngreso || null,
            // 🔧 VALIDACIÓN: Porcentaje debe ser número o null
            porcentaje_contratado: porcentajeContratado && porcentajeContratado !== '' ? parseInt(porcentajeContratado) : null,
            diligenciar_historias: resolverDiligenciarHistorias(),
            facturador: facturador // 🆕 Enviar campo facturador
        };

        if (usuarioActualizado == 1 && tipoUsuario !== '') {
            conf.tipo_usuario = parseInt(tipoUsuario, 10);
        } else if (crearCuenta && !esUsuarioSistema) {
            conf.tipo_usuario = parseInt(tipoUsuario, 10);
        } else if (!crearCuenta && !esUsuarioSistema) {
            // Personal sin acceso: placeholder administrativo (activo=0, no consume cupo)
            conf.tipo_usuario = 1;
            conf.crear_cuenta = false;
            conf.activar_directo = false;
        }

        if (password && String(password).trim()) {
            conf.password = String(password).trim();
        }

        conf.roles = JSON.stringify(usrRoles);

        axios.put('/user', conf)
            .then(() => {
                const ud = getUserData();
                if (ud && String(ud.user_id) === String(idUsuario)) {
                    const patch = {};
                    if (usuarioActualizado == 1 && tipoUsuario !== '') {
                        patch.tipo_usuario = parseInt(tipoUsuario, 10);
                    } else if (crearCuenta && !esUsuarioSistema) {
                        patch.tipo_usuario = parseInt(tipoUsuario, 10);
                    }
                    if (patch.tipo_usuario === 1) {
                        patch.vista_pi = 0;
                    }
                    if (Object.keys(patch).length > 0) {
                        persistUserData(patch);
                    }
                }
                setBanner({
                    type: 'success',
                    message: 'Los cambios se guardaron correctamente. Volviendo al listado…'
                });
                setLoading(false);
                setTimeout(() => {
                    localStorage.setItem('toastmsg', 'El usuario "' + name + ' ' + lastname + '" ha sido modificado');
                    history.push('/personal');
                }, 1400);
            })
            .catch((err) => {
                console.log('Error del servidor:', err.response?.data);
                const apiErrors = normalizeApiErrors(err);
                const generalMsg = apiErrors.general;
                const fieldErrors = { ...apiErrors };
                delete fieldErrors.general;
                setErrorlist(apiErrors);
                const fieldKeys = Object.keys(fieldErrors);
                const resumenApi = summarizeFieldErrors(fieldErrors);
                setBanner({
                    type: 'danger',
                    message:
                        generalMsg ||
                        resumenApi ||
                        (fieldKeys.length > 0
                            ? 'No se pudieron guardar los cambios. Revise los campos indicados.'
                            : 'Error al guardar. Intente de nuevo.')
                });
                if (fieldKeys.length > 0) {
                    requestAnimationFrame(() => scrollToFirstError(fieldKeys));
                }
                setLoading(false);
            });
    };

    const handleCrearAgendaUsuario = async () => {
        if (!idUsuario || creandoAgenda) return;

        if (!esUsuarioSistema || usuarioActivo !== 1) {
            setBanner({
                type: 'warning',
                message: 'El usuario debe tener acceso activo al sistema para crear y asignar una agenda.'
            });
            return;
        }

        const nombreAgenda = `${name} ${lastname}`.trim();
        if (!window.confirm(`¿Crear la agenda "${nombreAgenda}" y asignarla como favorita con permisos?`)) {
            return;
        }

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        setCreandoAgenda(true);
        clearBanner();

        try {
            const response = await axios.post(
                `/user/${idUsuario}/crear-agenda`,
                {},
                { headers: { Authorization: 'Bearer ' + userdata.access_token } }
            );

            setAgendaFavoritaId(response.data.agenda_id || null);
            setAgendaFavoritaNombre(response.data.agenda_nombre || `${name} ${lastname}`.trim());
            setBanner({
                type: 'success',
                message: response.data.message || 'Agenda creada y asignada correctamente.'
            });
        } catch (err) {
            setBanner({
                type: 'danger',
                message: err.response?.data?.message || 'No se pudo crear la agenda.'
            });
        } finally {
            setCreandoAgenda(false);
        }
    };

    const handleCrearCuenta = () => {
        if (esUsuarioSistema) {
            setBanner({
                type: 'warning',
                message: 'Este usuario ya tiene acceso activo al sistema. No puede desactivarse desde aquí.'
            });
            return;
        }

        if (!crearCuenta) {
            if (!hayCuposDisponibles) {
                setBanner({
                    type: 'danger',
                    message: 'No hay cupos disponibles para activar usuarios del sistema. Contacte al administrador.'
                });
                return;
            }

            clearBanner();
            setCrearCuenta(true);
            setAsignarRolesVisible('');
        } else {
            clearBanner();
            setCrearCuenta(false);
            setAsignarRolesVisible('hide');
        }
    };

    const passwordRequerida = crearCuenta && !esUsuarioSistema;








    // 🔒 PROTECCIÓN DE RUTA - Si no tiene permisos, mostrar página de acceso denegado
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (loggedIn) {
        return (

            <div className="wrapper hold-transition" style={{ fontSize: '13px' }}>
                <style>{`
                    .nu-section-card { border-radius: 12px !important; overflow: hidden; }
                    .nu-section-header {
                        background: #f8f9fa;
                        border-bottom: 1px solid #eef0f2;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 14px 18px;
                        user-select: none;
                    }
                    .nu-section-header:hover { background: #f3f5f7; }
                    .nu-section-title { font-size: 1rem; font-weight: 700; color: #323a45; margin: 0; display: flex; align-items: center; gap: 10px; }
                    .nu-fieldset {
                        border: 1px solid #eef0f2;
                        border-radius: 12px;
                        padding: 1.15rem 1.25rem 0.65rem;
                        margin-bottom: 1.15rem;
                        background: #fcfcfd;
                    }
                    .nu-fieldset legend {
                        float: none;
                        width: auto;
                        padding: 0 6px;
                        margin-bottom: 0.85rem;
                        font-size: 0.72rem;
                        font-weight: 700;
                        text-transform: uppercase;
                        letter-spacing: 0.45px;
                        color: #7d7d7d;
                    }
                    .nu-subcard {
                        border: 1px solid #e8ecef;
                        border-radius: 12px;
                        padding: 1.15rem 1.25rem;
                        background: #fff;
                        margin-top: 1rem;
                        box-shadow: 0 1px 3px rgba(0,0,0,0.05);
                    }
                    .nu-subcard legend {
                        float: none;
                        width: auto;
                        padding: 0 10px;
                        font-size: 0.92rem;
                        font-weight: 700;
                        color: #117a8b;
                        margin-bottom: 0.75rem;
                    }
                    .nu-alert-danger { border-radius: 10px; border: none; box-shadow: 0 2px 8px rgba(220,53,69,0.12); }
                    .nu-users-badge {
                        display: inline-block;
                        margin-top: 6px;
                        padding: 4px 12px;
                        border-radius: 999px;
                        font-size: 0.72rem;
                        font-weight: 700;
                        background: rgba(23,162,184,0.1);
                        color: #117f90;
                        border: 1px solid rgba(23,162,184,0.2);
                    }
                    .eu-cuenta-activa {
                        border-radius: 12px;
                        border: 1px solid rgba(23,162,184,0.35);
                        background: linear-gradient(135deg, rgba(23,162,184,0.12) 0%, rgba(23,162,184,0.06) 100%);
                        color: #0d5c6b;
                        padding: 14px 16px;
                    }
                    .role-selector-card {
                        display: flex;
                        align-items: center;
                        padding: 12px 15px;
                        border: 1px solid #e8ecef;
                        border-radius: 10px;
                        margin-bottom: 15px;
                        background: #ffffff;
                        cursor: pointer;
                        transition: all 0.2s ease;
                        box-shadow: 0 1px 3px rgba(0,0,0,0.04);
                    }
                    .role-selector-card:hover {
                        border-color: #17a2b8;
                        background: #f6fcfd;
                        transform: translateY(-1px);
                        box-shadow: 0 4px 12px rgba(23,162,184,0.1);
                    }
                    #role-form .sm-switch-container {
                        width: 44px !important;
                        height: 24px !important;
                        border-radius: 24px !important;
                        flex-shrink: 0;
                    }
                    #role-form .sm-switch-container .sm-switch {
                        width: 18px !important;
                        height: 18px !important;
                        top: 3px !important;
                        left: 3px !important;
                    }
                    #role-form .sm-switch-container.on .sm-switch {
                        left: 23px !important;
                    }
                    #role-form .role-selector-card .sm-switch-container {
                        margin-right: 12px;
                    }
                    .role-selector-card label {
                        margin: 0 !important;
                        cursor: pointer !important;
                        font-size: 14px !important;
                        font-weight: 600 !important;
                        color: #323a45 !important;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                    .nu-fieldset-inner { border: 1px solid #eef0f2; border-radius: 12px; padding: 1rem; background: #fafbfc; margin-top: 0.5rem; }
                    .nu-crear-cuenta-row {
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        gap: 12px 14px;
                        min-height: 38px;
                    }
                    .nu-crear-cuenta-row .nu-crear-cuenta-label {
                        margin: 0;
                        font-weight: 600;
                        color: #495057;
                        font-size: 13px;
                        line-height: 1.35;
                        flex: 1 1 140px;
                        min-width: 0;
                    }
                    .nu-crear-cuenta-row .sm-switch-container { flex-shrink: 0; align-self: center; }
                `}</style>
                <Header client={client} />
                <Aside client={client} activelink="settings" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb float-sm-left mb-0">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/personal-proveedores">Administrador de Personal y Proveedores</Link></li>
                                        <li className="breadcrumb-item" key="bc4"><Link to="/personal">Personal y Profesionales</Link></li>
                                        <li className="breadcrumb-item active" key="bc5">Editar personal</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2 align-items-center">
                                <div className="col-md-8">
                                    <h1 className="m-0" style={{ fontWeight: 700, fontSize: '1.5rem', color: '#323a45' }}>Editar personal</h1>
                                    <p className="text-muted mb-0 mt-1" style={{ fontSize: '0.85rem' }}>
                                        {name || lastname ? `${name} ${lastname}`.trim() : 'Modifique datos y permisos del colaborador.'}
                                    </p>
                                </div>
                                <div className="col-md-4 mt-2 mt-md-0 text-md-right">
                                    <Link to="/personal" className="btn btn-outline-secondary btn-sm" style={{ borderRadius: '10px', fontWeight: 600 }}>
                                        <i className="fas fa-arrow-left mr-1"></i> Volver al listado
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            <div className="row">
                                <div className="col-md-12">

                                    <form id="role-form" onSubmit={handleSubmit}>

                                        {banner.type && banner.message ? (
                                            <div
                                                className={`alert ${
                                                    banner.type === 'success'
                                                        ? 'alert-success'
                                                        : banner.type === 'warning'
                                                          ? 'alert-warning'
                                                          : 'alert-danger nu-alert-danger'
                                                } mb-3`}
                                                role="alert"
                                            >
                                                <i
                                                    className={`fas ${
                                                        banner.type === 'success' ? 'fa-check-circle' : 'fa-exclamation-triangle'
                                                    } mr-2`}
                                                    aria-hidden="true"
                                                ></i>
                                                {banner.message}
                                            </div>
                                        ) : null}

                                        <div className="card shadow-sm border-0 mb-4 nu-section-card">
                                            <div className="card-header nu-section-header border-0 rounded-0" onClick={() => setAcordeonDatosBasicos(!acordeonDatosBasicos)}>
                                                <h2 className="nu-section-title">
                                                    <i className="fas fa-id-card text-info" style={{ opacity: 0.9 }} aria-hidden="true"></i>
                                                    Datos básicos
                                                </h2>
                                                <i className={`fas fa-chevron-${acordeonDatosBasicos ? 'up' : 'down'} text-muted`} aria-hidden="true"></i>
                                            </div>
                                            <div id="infobasica-edit" className={acordeonDatosBasicos ? '' : 'collapse'}>
                                                <div className="card-body pt-3">

                                                    <fieldset className="nu-fieldset">
                                                        <legend>Información personal</legend>

                                                        <div className="row">
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="name">Nombres <span className="text-danger">*</span></label>
                                                                    <input type="text" name="name" className={`form-control${errorlist.name ? ' is-invalid' : ''}`} value={name} id="name" onChange={(e) => setName(e.target.value)} />
                                                                    <div className="invalid-feedback d-block">
                                                                        {errorlist.name}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="lastname">Apellidos <span className="text-danger">*</span></label>
                                                                    <input type="text" name="lastname" className={`form-control${errorlist.lastname ? ' is-invalid' : ''}`} value={lastname} id="lastname" onChange={(e) => setLastname(e.target.value)} />
                                                                    <div className="invalid-feedback d-block">
                                                                        {errorlist.lastname}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                             <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="tipo_documento">Tipo documento <span className="text-danger">*</span></label>
                                                                    <select name="tipo_documento" id="tipo_documento" className={`form-control${errorlist.tipo_documento ? ' is-invalid' : ''}`} value={tipoDocumento || ''} onChange={(e) => setTipoDocumento(e.target.value)}>
                                                                        <option value="">-</option>
                                                                        <option value="cc">CC - CEDULA DE CIUDADANIA</option>
                                                                        <option value="ce">CE - CEDULA DE EXTRANJERIA</option>
                                                                        <option value="CD">CD - CARNET DIPLOMATICO</option>
                                                                        <option value="CN">CN - CERTIFICADO DE NACIDO VIVO</option>
                                                                        <option value="DE">DE - DOCUMENTOS EXTRANJERO</option>
                                                                        <option value="MS">MS - MENOR SIN IDENTIFICAR</option>
                                                                        <option value="NIP">NIP - NUMERO DE IDENTIFICACION PERSONAL</option>
                                                                        <option value="NIT">NIT - NUMERO DE IDENTIFICACION TRIBUTARIA</option>
                                                                        <option value="PA">PA - PASAPORTE</option>
                                                                        <option value="PT">PT - PERMISO TEMPORAL DE PERMANENCIA</option>
                                                                        <option value="PE">PE - PERMISO ESPECIAL DE PERMANENCIA</option>
                                                                        <option value="RC">RC - REGISTRO CIVIL</option>
                                                                        <option value="ti">TI - TARJETA DE IDENTIDAD</option>
                                                                        <option value="SC">SC - SALVOCONDUCTO DE PERMANENCIA</option>
                                                                        <option value="SI">SI - SIN IDENTIFICACION</option>
                                                                        <option value="AS">AS - ADULTO SIN IDENTIFICAR</option>
                                                                    </select>
                                                                    <div className="invalid-feedback d-block">
                                                                        {errorlist.tipo_documento}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="documento">Documento <span className="text-danger">*</span></label>
                                                                    <input type="text" name="documento" className={`form-control${errorlist.numero_documento ? ' is-invalid' : ''}`} id="documento" value={documento} onChange={(e) => setDocumento(e.target.value)} />
                                                                    <div className="invalid-feedback d-block">
                                                                        {errorlist.numero_documento}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                           
                                                        </div>

                                                    </fieldset>

                                                    <fieldset className="nu-fieldset">
                                                        <legend>Información de contacto</legend>
                                                        <div className="row">
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="direccion">Dirección</label>
                                                                    <input type="text" name="direccion" className="form-control" id="direccion" value={direccion} onChange={(e) => setDireccion(e.target.value)} />
                                                                    <div className="invalid-feedback visible">
                                                                        {errorlist.direccion}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="ciudadResidencia">Ciudad de residencia</label>
                                                                    <SelectorCiudad
                                                                        value={ciudadResidencia}
                                                                        onChange={setCiudadResidencia}
                                                                    />
                                                                    <div className="invalid-feedback visible">
                                                                        {errorlist.ciudad}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="telefono">Teléfono fijo</label>
                                                                    <input type="text" name="telefono" className="form-control" id="telefono" value={telefono} onChange={(e) => setTelefono(e.target.value)} />
                                                                    <div className="invalid-feedback visible">
                                                                        {errorlist.telefono}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="celular">Teléfono celular <span className="text-danger">*</span></label>
                                                                    <input type="text" name="celular" className={`form-control${errorlist.celular ? ' is-invalid' : ''}`} id="celular" value={celular} onChange={(e) => setCelular(e.target.value)} />
                                                                    <div className="invalid-feedback d-block">
                                                                        {errorlist.celular}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="email">Email <span className="text-danger">*</span></label>
                                                                    <input type="text" name="email" className={`form-control${errorlist.email ? ' is-invalid' : ''}`} id="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                                                                    <div className="invalid-feedback d-block">
                                                                        {errorlist.email}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="fecha_nacimiento">Fecha de nacimiento</label>
                                                                    <input type="date" name="fecha_nacimiento" className="form-control" id="fecha_nacimiento" value={fechaNacimiento} onChange={(e) => setFechaNacimiento(e.target.value)} />
                                                                    <div className="invalid-feedback visible">
                                                                        {errorlist.fecha_nacimiento}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="estado_civil">Estado civil</label>
                                                                    <select name="tipo-sangre" className="form-control" id="estadoCivil" value={estadoCivil || ''} onChange={(e) => setEstadoCivil(e.target.value)}>
                                                                        <option value="">-</option>
                                                                        <option value="soltero">SOLTERO</option>
                                                                        <option value="casado">CASADO</option>
                                                                        <option value="separado">SEPARADO</option>
                                                                        <option value="viudo">VIUDO</option>
                                                                        <option value="union_libre">UNIÓN LIBRE</option>
                                                                        <option value="otro">OTRO</option>
                                                                    </select>
                                                                    <div className="invalid-feedback visible">
                                                                        {errorlist.estado_civil}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="tipo_contrato">Tipo de contrato <span className="text-danger">*</span></label>
                                                                    <select name="tipo_contrato" id="tipo_contrato" className={`form-control${errorlist.tipo_contrato ? ' is-invalid' : ''}`} value={tipoContrato || ''} onChange={(e) => setTipoContrato(e.target.value)}>
                                                                        <option value="">-</option>
                                                                        {
                                                                            tiposContrato.map((tc) =>
                                                                                <option key={tc.id} value={tc.id}>{tc.nombre}</option>
                                                                            )
                                                                        }

                                                                    </select>
                                                                    <div className="invalid-feedback d-block">
                                                                        {errorlist.tipo_contrato}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </fieldset>

                                                </div>
                                            </div>
                                        </div>

                                        <div className="card shadow-sm border-0 mb-4 nu-section-card">
                                            <div className="card-header nu-section-header border-0 rounded-0" onClick={() => setAcordeonDatosProfesional(!acordeonDatosProfesional)}>
                                                <h2 className="nu-section-title">
                                                    <i className="fas fa-user-md text-info" style={{ opacity: 0.9 }} aria-hidden="true"></i>
                                                    Profesional de la salud
                                                </h2>
                                                <i className={`fas fa-chevron-${acordeonDatosProfesional ? 'up' : 'down'} text-muted`} aria-hidden="true"></i>
                                            </div>
                                            <div id="datosadicionales-edit" className={acordeonDatosProfesional ? '' : 'collapse'}>
                                                <div className="card-body pt-3">

                                                    <fieldset className="nu-fieldset">
                                                        <legend>Información laboral</legend>
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <label htmlFor="fecha_ingreso">Fecha de ingreso</label>
                                                                    <input type="date" name="fecha_ingreso" className="form-control" id="fecha_ingreso" value={fechaIngreso} onChange={(e) => setFechaIngreso(e.target.value)} />
                                                                    <div className="invalid-feedback visible">
                                                                        {errorlist.fecha_ingreso}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <label htmlFor="cargo">Cargo</label>
                                                                    <select name="cargo" id="cargo" className="form-control" value={cargo || ''} onChange={(e) => setCargo(e.target.value)}>
                                                                        <option value="">-</option>
                                                                        {
                                                                            cargos.map((cargoItem) =>
                                                                                <option key={cargoItem.id} value={cargoItem.id}>{cargoItem.nombre}</option>
                                                                            )
                                                                        }
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <label htmlFor="registro_medico">Registro Médico</label>
                                                                    <input type="text" name="registro_medico" className="form-control" id="registro_medico" value={registroMedico} onChange={(e) => setRegistroMedico(e.target.value)} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <label htmlFor="especialidad">Especialidad</label>
                                                                    <select name="especialidad" id="especialidad" className="form-control" value={especialidad || ''} onChange={(e) => setEspecialidad(e.target.value)}>
                                                                        <option value="">-</option>
                                                                        {
                                                                            especialidades.map((especialidadItem) =>
                                                                                <option key={especialidadItem.id} value={especialidadItem.id}>{especialidadItem.nombre}</option>
                                                                            )
                                                                        }
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <label htmlFor="codigo_habilitacion">Código de Habilitación</label>
                                                                    <input type="text" name="codigo_habilitacion" className="form-control" id="codigo_habilitacion" value={codigoHabilitacion} onChange={(e) => setCodigoHabilitacion(e.target.value)} />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <label htmlFor="porcentaje_contratado">Porcentaje contratado</label>
                                                                    <input type="number" min="0" max="100" name="porcentaje_contratado" className={`form-control${errorlist.porcentaje_contratado ? ' is-invalid' : ''}`} id="porcentaje_contratado" value={porcentajeContratado} onChange={(e) => setPorcentajeContratado(e.target.value)} />
                                                                    <div className="invalid-feedback d-block">
                                                                        {errorlist.porcentaje_contratado}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </fieldset>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="card shadow-sm border-0 mb-4 nu-section-card">
                                            <div className="card-header nu-section-header border-0 rounded-0" onClick={() => setAcordeonUsuarioSistema(!acordeonUsuarioSistema)}>
                                                <h2 className="nu-section-title">
                                                    <i className="fas fa-key text-info" style={{ opacity: 0.9 }} aria-hidden="true"></i>
                                                    Usuario del sistema
                                                </h2>
                                                <i className={`fas fa-chevron-${acordeonUsuarioSistema ? 'up' : 'down'} text-muted`} aria-hidden="true"></i>
                                            </div>
                                            <div id="rolesusuario-edit" className={acordeonUsuarioSistema ? '' : 'collapse'}>
                                                <div className="card-body pt-3">

                                                    {!esUsuarioSistema && (
                                                        <div className="row">
                                                            <div className="col-md-3">
                                                                <div className="form-group mb-2">
                                                                    <div className="nu-crear-cuenta-row">
                                                                        <label className="nu-crear-cuenta-label" htmlFor="crear_cuenta">
                                                                            ¿Crear cuenta de usuario en la plataforma?
                                                                        </label>
                                                                        <div
                                                                            className={'sm-switch-container ' + (crearCuenta ? 'on' : '')}
                                                                            id="crear_cuenta"
                                                                            onClick={handleCrearCuenta}
                                                                        >
                                                                            <span className="sm-switch"></span>
                                                                        </div>
                                                                    </div>
                                                                    <span className="nu-users-badge mt-2 d-inline-block" title="Cupos por tipo de usuario activo">
                                                                        Médicos: {cuposMedicos.creados}/{cuposMedicos.disponibles} (libres {cuposLibresMedicos})
                                                                        {' · '}
                                                                        Admin: {cuposAdmin.creados}/{cuposAdmin.disponibles} (libres {cuposLibresAdmin})
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}

                                                    {esUsuarioSistema && usuarioTieneCuenta && (
                                                        <div className="row mb-3">
                                                            <div className="col-md-12">
                                                                <div className="eu-cuenta-activa" role="status">
                                                                    <i className="fas fa-user-check mr-2" aria-hidden="true"></i>
                                                                    <strong>Este usuario ya tiene acceso activo al sistema.</strong>
                                                                    <p className="mb-0 mt-2 small">No se puede desactivar desde aquí. Solo el administrador del sistema puede hacerlo.</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}

                                                    {esUsuarioSistema && !usuarioTieneCuenta && (
                                                        <div className="row mb-3">
                                                            <div className="col-md-12">
                                                                <div className="alert alert-warning mb-0" role="status">
                                                                    <strong>Acceso pendiente.</strong> Este profesional está activo pero aún debe completar la actualización de acceso (email/contraseña).
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}

                                                    {(crearCuenta || esUsuarioSistema) && (
                                                        <>
                                                            <fieldset className="nu-subcard">
                                                                <legend>Datos de inicio de sesión</legend>
                                                                <div className="row">
                                                                    {!esUsuarioSistema && (
                                                                        <div className="col-md-6">
                                                                            <div className="form-group">
                                                                                <label htmlFor="tipo_usuario">
                                                                                    Tipo de usuario <span className="text-danger">*</span>
                                                                                </label>
                                                                                <select
                                                                                    name="tipo_usuario"
                                                                                    id="tipo_usuario"
                                                                                    className={`form-control${errorlist.tipo_usuario ? ' is-invalid' : ''}`}
                                                                                    value={tipoUsuario}
                                                                                    onChange={(e) => setTipoUsuario(e.target.value)}
                                                                                    style={{ borderRadius: '10px' }}
                                                                                >
                                                                                    <option value="0">Médico / Especialista ({cuposLibresMedicos} cupos libres)</option>
                                                                                    <option value="1">Administrativo / Recepción ({cuposLibresAdmin} cupos libres)</option>
                                                                                </select>
                                                                                <div className="invalid-feedback d-block">{errorlist.tipo_usuario}</div>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                    <div className={!esUsuarioSistema ? 'col-md-6' : 'col-md-12'}>
                                                                        <div className="form-group">
                                                                            <label htmlFor="password_edit">
                                                                                Contraseña{passwordRequerida ? <span className="text-danger"> *</span> : ' (opcional)'}
                                                                            </label>
                                                                            <input
                                                                                type="password"
                                                                                name="password"
                                                                                className={`form-control${errorlist.password ? ' is-invalid' : ''}`}
                                                                                id="password_edit"
                                                                                autoComplete="new-password"
                                                                                value={password}
                                                                                onChange={(e) => setPassword(e.target.value)}
                                                                                placeholder={passwordRequerida ? 'Mínimo 6 caracteres' : 'Mín. 6 caracteres si la completa'}
                                                                            />
                                                                            <small className="form-text text-muted">
                                                                                {passwordRequerida
                                                                                    ? 'Obligatoria para activar el acceso. El usuario ingresa con su email.'
                                                                                    : 'Complete solo si desea cambiar la contraseña actual.'}
                                                                            </small>
                                                                            <div className="invalid-feedback d-block">{errorlist.password}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </fieldset>

                                                            {usuarioActualizado == 1 && esUsuarioSistema && (
                                                                <fieldset className="nu-subcard">
                                                                    <legend>Tipo de Usuario y Cupo</legend>
                                                                    <div className="row">
                                                                        <div className="col-md-6">
                                                                            <div className="form-group">
                                                                                <label htmlFor="tipo_usuario">Rol / Tipo de Usuario (Consume Cupo)</label>
                                                                                <select
                                                                                    name="tipo_usuario"
                                                                                    id="tipo_usuario"
                                                                                    className={`form-control${errorlist.tipo_usuario ? ' is-invalid' : ''}`}
                                                                                    value={tipoUsuario}
                                                                                    onChange={(e) => setTipoUsuario(e.target.value)}
                                                                                    style={{ borderRadius: '10px' }}
                                                                                >
                                                                                    <option value="0">Médico / Especialista</option>
                                                                                    <option value="1">Administrativo / Recepción</option>
                                                                                </select>
                                                                                <div className="invalid-feedback d-block">{errorlist.tipo_usuario}</div>
                                                                                <small className="form-text text-muted">
                                                                                    Al cambiar el tipo, el sistema validará si hay cupos disponibles.
                                                                                </small>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </fieldset>
                                                            )}

                                                            <fieldset className="nu-subcard">
                                                                <legend>Agenda</legend>
                                                                {agendaFavoritaId ? (
                                                                    <div className="alert alert-success mb-0 py-2">
                                                                        <i className="fas fa-calendar-check mr-2" aria-hidden="true"></i>
                                                                        <strong>Agenda favorita:</strong>{' '}
                                                                        {agendaFavoritaNombre || `ID ${agendaFavoritaId}`}
                                                                    </div>
                                                                ) : (
                                                                    <>
                                                                        <p className="text-muted small mb-2">
                                                                            Este usuario no tiene agenda favorita. Puede crear una con su nombre y asignarle permisos automáticamente.
                                                                        </p>
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-info"
                                                                            style={{ borderRadius: '10px' }}
                                                                            onClick={handleCrearAgendaUsuario}
                                                                            disabled={creandoAgenda || usuarioActivo !== 1}
                                                                        >
                                                                            {creandoAgenda ? (
                                                                                <>
                                                                                    <i className="fas fa-spinner fa-spin mr-1"></i>
                                                                                    Creando agenda…
                                                                                </>
                                                                            ) : (
                                                                                <>
                                                                                    <i className="fas fa-calendar-plus mr-1"></i>
                                                                                    Crear agenda y asignar
                                                                                </>
                                                                            )}
                                                                        </button>
                                                                    </>
                                                                )}
                                                            </fieldset>

                                                            <fieldset className="nu-subcard">
                                                                <legend>Permisos de facturación</legend>
                                                                <div className="row">
                                                                    <div className="col-md-12">
                                                                        <label htmlFor="facturador" className="font-weight-bold text-secondary">¿Es facturador?</label>
                                                                        <select
                                                                            className="form-control mt-1"
                                                                            value={facturador}
                                                                            onChange={(e) => setFacturador(parseInt(e.target.value))}
                                                                            style={{ maxWidth: '520px', borderRadius: '10px' }}
                                                                        >
                                                                            <option value={0}>Sí - Puede crear RIPS FEV y Convenios</option>
                                                                            <option value={1}>No - Solo RIPS Sin FEV</option>
                                                                        </select>
                                                                        <small className="form-text text-muted">
                                                                            Define qué opciones de RIPS puede usar el usuario al atender pacientes
                                                                        </small>
                                                                    </div>
                                                                </div>
                                                            </fieldset>

                                                            <div className={'row ' + asignarRolesVisible} style={{ marginTop: '12px' }}>
                                                                <div className="col-md-12">
                                                                    <fieldset className="nu-fieldset-inner">
                                                                        <legend className="mb-3" style={{ fontSize: '0.92rem', fontWeight: 700, color: '#117a8b', border: 'none', padding: 0 }}>Asignar perfil de usuario</legend>
                                                                        <div className="row">
                                                                            {roles.map((role) =>
                                                                                <div className="col-md-4" key={'role-' + role.id}>
                                                                                    <div className="role-selector-card" onClick={() => addRole(role.id)}>
                                                                                        <div
                                                                                            className={'sm-switch-container ' + (usrRoles.indexOf(role.id) > -1 ? 'on' : '')}
                                                                                            id={'role-' + role.id}
                                                                                        >
                                                                                            <span className="sm-switch"></span>
                                                                                        </div>
                                                                                        <label title={role.name}>{role.name}</label>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </fieldset>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}

                                                </div>
                                            </div>
                                        </div>

                                        <div className="row align-items-center mb-4" style={{ marginTop: '8px' }}>
                                            <div className="col-md-auto pr-md-2">
                                                <button type="submit" className="btn btn-info font-weight-bold px-4" disabled={loading} style={{ borderRadius: '10px', minWidth: '200px' }}>
                                                    {loading ? (
                                                        <>
                                                            <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                                            Guardando…
                                                        </>
                                                    ) : (
                                                        <>
                                                            <i className="fas fa-save mr-2"></i>
                                                            Guardar cambios
                                                        </>
                                                    )}
                                                </button>
                                            </div>
                                            <div className="col-md-auto pt-2 pt-md-0">
                                                <Link to="/personal" className="btn btn-outline-secondary" style={{ borderRadius: '10px' }}>
                                                    Cancelar
                                                </Link>
                                            </div>
                                        </div>

                                    </form>
                                </div>
                            </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>

        );
    }

    return (
        <Loading />
    );
}
export default EditarUsuario;